import { apiUrl } from "./config";
import { BeaOffer } from "./types";

export async function getBeaOffers(): Promise<{ beaOffers: BeaOffer[] }> {
  const res = await fetch(`//${apiUrl}/public/bea_offers`);
  const { bea_offers } = await res.json();
  const transformed = bea_offers.map((beaOffer: BeaOffer) => {
    return {
      ...beaOffer,
    };
  });
  return {
    beaOffers: transformed,
  };
}



// WEBPACK FOOTER //
// ./src/api.tsx